import type { GetStaticProps } from 'next';

import { makeEnergyInsightsPage } from '../../modules/energy-insights/energy-insights-page';
import { makeGetStaticPropsRequest } from '../../modules/energy-insights/get-static-props';
import type { EnergyInsightsPageProps } from '../../modules/energy-insights/types';

const EnergyInsightsPage = makeEnergyInsightsPage();
export default EnergyInsightsPage;

export const getStaticProps: GetStaticProps<EnergyInsightsPageProps> = makeGetStaticPropsRequest(
  'energy-insights',
  'No energy insights page entry found'
);
